import React from "react";
import Style from "../../styles/Style";
import './Feedback.scss'

const FEEDBACK_BOX_ID = 'feedbackBox'
enum Structure {
    feedback = 'feedback',
    success = 'success',
    error = 'error'
}
export default function Feedback(){
    return <div id={FEEDBACK_BOX_ID}></div>
}

enum ResponseType {
    success = 0,
    error = 1
}
interface LogType {
    status: number
    message: string
}
export function addLog(log: LogType){
    const feedbackWindow = document.querySelector(`#${FEEDBACK_BOX_ID}`);

    if(!feedbackWindow){
        return
    }

    const feedbackType = log.status === ResponseType.success ? 'success' : 'error'

    const newFeedbackBox = document.createElement('div');
    newFeedbackBox.innerHTML = log.message || '';
    newFeedbackBox.className = `${Structure.feedback} ${Style.effects.shadow.dark} ${Style.animations.slideInFromBottom} ${feedbackType}`;
    feedbackWindow.append(newFeedbackBox);

    const feedbackLogTimeout: NodeJS.Timeout = setTimeout(() => {
        if (newFeedbackBox) newFeedbackBox.remove();
    }, 6000);
    newFeedbackBox.addEventListener('click', () => {
        if (feedbackLogTimeout) clearTimeout(feedbackLogTimeout);
        if (newFeedbackBox) newFeedbackBox.remove();
    });
}